import { createTheme } from "@mui/material/styles";

export const MUITheme = createTheme({
    typography: {
        fontFamily: "Mulish",
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    marginTop: "initial",
                    marginLeft: "initial",
                    width: "100%",
                },
            },
        },
    },
});
